import React from "react";
import t from "i18n";

const PaperFilterTypeSilo = ({ activeTab, onActiveTabChange }) => {
  return (
    <div style={{ display: "flex", gap: 30, width: "50%" }}>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTab === "type" ? "bold" : "normal",
          borderBottom: activeTab === "type" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTab === "type" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: '100%',
          textAlign: "center",
        }}
        onClick={() => onActiveTabChange("type")}
      >
        {t('Type')}
      </span>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTab === "silo" ? "bold" : "normal",
          borderBottom: activeTab === "silo" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTab === "silo" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: '100%',
          textAlign: "center",
        }}
        onClick={() => onActiveTabChange("silo")}
      >
        {t('Silo')}
      </span>
    </div>
  );
};

export default PaperFilterTypeSilo;


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperFilterTypeSilo.js